import t from "./highrise1308.mjs";
import i from "./highrise1309.mjs";
var s = Object.prototype, p = s.hasOwnProperty;
function l(r, a, o) {
  var n = r[a];
  (!(p.call(r, a) && i(n, o)) || o === void 0 && !(a in r)) && t(r, a, o);
}
export {
  l as default
};
